import type * as React from "react";
import { cn } from "@/lib/utils";

export function Input(props: React.InputHTMLAttributes<HTMLInputElement>) {
  const { className, ...rest } = props;

  return (
    <input
      className={cn(
        "h-10 w-full rounded-md border border-neutral-300 bg-gray-100 px-3 text-sm text-neutral-900 placeholder:text-neutral-400 outline-none focus:border-black",
        className,
      )}
      {...rest}
    />
  );
}
